/* eslint-disable no-console */

/**
 * End-to-end SIP selection flow tracer.
 *
 * Logs the whole path so the frontend flow is readable at a glance:
 *   line selected -> getAvailable result -> claim id sent -> redux state id ->
 *   getById resolved line -> register.
 *
 * Field names are explicit about the two ids that are easy to confuse:
 *   - claimSipId: sip.id (getAvailable.sipToDispatcherId) — used ONLY to claim/lock a line.
 *   - linkId:     sipToDispatcher.id (getAvailable.sipId) — used for redux state / getById / calls.
 *   - stateId:    redux state.sipToDispatcher.id (must equal linkId after the fix).
 *
 * Uses console.info directly on purpose: logger.util's `info` is a no-op off
 * localhost, but this trace must stay visible on dev/prod while debugging.
 */
export const sipFlowLog = (step: string, data?: Record<string, unknown>) => {
	console.info(`[SIP flow] ${step}`, data ?? {});
};

export default sipFlowLog;
